import {
    SET_PLAYER_TEXT,
    SET_PLAYERS_TEXT,
    SET_TESTSERVER_TEXT,
    SET_TESTSERVERWARNING_TEXT,
    SET_ONTESTSERVER_TEXT,
    SET_TEXTS,
} from './constants'

export function setPlayerText(text) {
    return {
        type: SET_PLAYER_TEXT,
        payload: text,
    }
}

export function setPlayersText(text) {
    return {
        type: SET_PLAYERS_TEXT,
        payload: text,
    }
}

export function setTestServerText(text) {
    return {
        type: SET_TESTSERVER_TEXT,
        payload: text,
    }
}

export function setTestServerWarningText(text) {
    return {
        type: SET_TESTSERVERWARNING_TEXT,
        payload: text,
    }
}

export function setOnTestServerText(text) {
    return {
        type: SET_ONTESTSERVER_TEXT,
        payload: text,
    }
}

export function setTexts(texts) {
    return {
        type: SET_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/texts/actions.js